import { getAdminThemeVars } from './get-admin-theme-vars.js'

export function getMissingThemeVars(existingBlock: string): string[] {
  return getAdminThemeVars()
    .filter((line) => {
      const varName = line.trim().split(':')[0]!.trim()
      return !existingBlock.includes(varName)
    })
    .map((line) => `  ${line.trim()}`)
}
